import { IZFButtonProps } from "../../component";
import ZFIcon from "../ZFIcon/ZFIcon";
import React from "react";
import {
	ButtonState,
	ButtonSubType,
	ButtonType,
	IconProperties,
} from "./ZFButton.d";

const componentClassPrefix = "zf-btn";
const separator = "-";

const getButtonProperties = (
	buttonType?: ButtonType,
	iconProperties?: IconProperties,
	href?: string,
	outline?: boolean,
	state?: ButtonState
) => {
	let btnType: string = buttonType ? buttonType : ButtonType.primary;

	if (iconProperties) {
		btnType += ButtonSubType.linkIcon;
	} else if (href) {
		btnType += ButtonSubType.link;
	} else if (outline) {
		btnType += ButtonSubType.outline;
	}

	const btnState = state ? state : ButtonState.default;
	const btnClass =
		componentClassPrefix + separator + btnType + separator + btnState;

	return { btnType, btnState, btnClass };
};

const ZFButton: React.FC<IZFButtonProps> = (props: IZFButtonProps) => {
	const { btnState, btnClass } = getButtonProperties(
		props.buttonType,
		props.iconProperties,
		props.href,
		props.outline,
		props.state
	);
	const buttonClass: string[] = [];

	const iconProperties = props.iconProperties;
	const onButtonClick = () => props.onBtnClick();

	buttonClass.push("zf-btn", btnClass);

	if (props.buttonClasses) {
		buttonClass.push(...props.buttonClasses);
	}

	const btnClasses = buttonClass.join(" ");

	return (
		<>
			<button
				disabled={btnState === "disabled"}
				className={btnClasses}
				onClick={() => onButtonClick()}
			>
				{iconProperties && (
					<ZFIcon
						iconName={iconProperties.iconName}
						isActive={btnState === "active"}
						iconClasses={iconProperties.iconClasses}
					/>
				)}
				{props.children}
			</button>
		</>
	);
};

export default ZFButton;
